const SHEET_ID = '1Lb9QEwmF-gKDdLvcgFVM8wVJ1Ol8uTwyKmHiM_FTBJc';
const SHEET_NAME = 'menu';

const SAME_ORIGIN_MENU_ENDPOINT = '/api/menu.php';

const CATEGORY_ORDER = [
  'Kalte Speisen',
  'Warme Speisen',
  'Für Vegetarier',
  'Extras',
  'Kaffee & Tee',
  'Alkoholfreie Getränke',
  'Bier & Most',
  'Wein'
];

function isLocalDevelopment() {
  return ['localhost', '127.0.0.1'].includes(window.location.hostname);
}

function getCategoryOrder(title) {
  const normalizedTitle = String(title || '').trim().toLowerCase();

  const index = CATEGORY_ORDER.findIndex(
    (category) => category.toLowerCase() === normalizedTitle
  );

  return index === -1 ? 999 : index;
}

function parseGoogleSheetResponse(text) {
  const match = text.match(/google\.visualization\.Query\.setResponse\((.*)\);?\s*$/s);

  if (!match?.[1]) {
    throw new Error('Google-Sheets-Antwort konnte nicht gelesen werden.');
  }

  return JSON.parse(match[1]);
}

function parseBoolean(value) {
  if (value === true || value === false) return value;

  const normalized = String(value || '').trim().toLowerCase();
  return ['true', 'wahr', 'yes', 'ja', '1', 'x'].includes(normalized);
}

function getCellValue(cells, index) {
  return cells[index]?.v ?? cells[index]?.w ?? cells[index]?.f ?? '';
}

function mapRowsToItems(rows) {
  return rows.map((row) => {
    const cells = row.c || [];

    return {
      categoryId: getCellValue(cells, 0),
      categoryTitle: getCellValue(cells, 1),
      placeholderImage: getCellValue(cells, 2),
      itemName: getCellValue(cells, 3),
      price: getCellValue(cells, 4),
      image: getCellValue(cells, 5),
      imageAlt: getCellValue(cells, 6),
      sortOrder: Number(getCellValue(cells, 7) || 0),
      active: parseBoolean(getCellValue(cells, 8))
    };
  });
}

function groupMenuItems(items) {
  const grouped = {};

  items
    .filter((item) => item.active && item.categoryId && item.itemName)
    .forEach((item) => {
      if (!grouped[item.categoryId]) {
        grouped[item.categoryId] = {
          id: item.categoryId,
          title: item.categoryTitle,
          placeholderImage: item.placeholderImage,
          items: []
        };
      }

      grouped[item.categoryId].items.push({
        name: item.itemName,
        price: item.price,
        image: item.image,
        imageAlt: item.imageAlt,
        sortOrder: item.sortOrder
      });
    });

  return Object.values(grouped)
    .map((category) => ({
      ...category,
      items: category.items.sort((a, b) => {
        return (a.sortOrder - b.sortOrder) || a.name.localeCompare(b.name, 'de');
      })
    }))
    .sort((a, b) => {
      const categoryOrderA = getCategoryOrder(a.title);
      const categoryOrderB = getCategoryOrder(b.title);

      return (
        categoryOrderA - categoryOrderB ||
        a.title.localeCompare(b.title, 'de')
      );
    });
}

async function getMenuDirectlyFromGoogleForLocalDevelopment() {
  const url = `https://docs.google.com/spreadsheets/d/${SHEET_ID}/gviz/tq?sheet=${encodeURIComponent(
    SHEET_NAME
  )}&tqx=out:json`;

  const response = await fetch(url);

  if (!response.ok) {
    throw new Error(`Google Sheet konnte nicht geladen werden. Status: ${response.status}`);
  }

  const text = await response.text();
  const parsed = parseGoogleSheetResponse(text);
  const rows = parsed.table?.rows || [];
  const flatItems = mapRowsToItems(rows);

  return groupMenuItems(flatItems);
}

async function getMenuFromSameOriginProxy() {
  const response = await fetch(SAME_ORIGIN_MENU_ENDPOINT, {
    method: 'GET',
    headers: {
      Accept: 'application/json'
    }
  });

  if (!response.ok) {
    throw new Error(`Speisekarte konnte nicht geladen werden. Status: ${response.status}`);
  }

  const data = await response.json();

  if (!Array.isArray(data)) {
    throw new Error('Speisekartenformat ist ungültig.');
  }

  return data;
}

export async function getMenu() {
  if (isLocalDevelopment()) {
    return getMenuDirectlyFromGoogleForLocalDevelopment();
  }

  return getMenuFromSameOriginProxy();
}